import React from "react";
import { RouteComponentProps } from "react-router";
import { Redirect } from "react-router-dom";
import { useAuthContext } from "../../../lib/context/Auth/AuthContext";
import { BOOKINGS_ROOT_PATH } from "../../../lib/routes/routes";
import { BookingsDesksSearch } from "./BookingsDesksSearch/BookingsDesksSearch";
import { BookingsRoomsSearch } from "./BookingsRoomsSearch/BookingsRoomsSearch";

export type BookingTypes = "room" | "desk";

interface Props {
  type: string;
}

const components: {
  [key in BookingTypes]: React.FunctionComponent<any>;
} = {
  room: BookingsRoomsSearch,
  desk: BookingsDesksSearch,
};

export const BookingsSearch = ({
  match: {
    params: { type },
  },
}: RouteComponentProps<Props>) => {
  const { user } = useAuthContext();
  const Component = components[type as BookingTypes];

  if (
    (user && type === "room" && !user.roomBookingEnabled) ||
    (user && type === "desk" && !user.deskBookingEnabled)
  ) {
    return <Redirect to={BOOKINGS_ROOT_PATH} />;
  }

  return <Component type={type} />;
};
